import clsx from "clsx";

const Tabs = ({ items, active, unread, setActive }) => {
  return (
    <div className="flex gap-4 h-6 pl-2">
      {items.map((item) => (
        <p
          key={item}
          id={item}
          className={clsx("cursor-pointer text-dimgray-200 text-[14px] min-w-[72px] text-center", {
            '!text-dark-blue-100 font-bold relative after:absolute after:left-0 after:-bottom-[1.5px] after:content-[""] after:bg-dark-blue-100 after:w-full min-w-[72px] text-center after:h-[2.5px] ':
              active === item,
          })}
          onClick={() => setActive(item)}
        >
          {
            item
          }
        </p>
      ))}
    </div>
  );
};

export default Tabs;
